import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import RadialGradient from '@bubble-ui/primitive-radial-gradient';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationCreditRefusalRational = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationCreditRefusalRational',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70100)",
    fillRule: "evenodd",
    d: "M89.5 7.45c5.7 0 10.35 4.55 10.5 10.22v47.28c0 5.7-4.55 10.35-10.22 10.5H10.5C4.8 75.45.15 70.9 0 65.23V17.95c0-5.7 4.55-10.35 10.22-10.5H89.5Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70100)",
    d: "M100 21.45H0v10.01h100V21.45Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_radial_21134_70100)",
    fillRule: "evenodd",
    d: "M50.51 46.41c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24c0-13.26-10.75-24-24-24Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M46.65 81.42c0-2.12 1.6-3.72 3.72-3.72s3.72 1.6 3.72 3.72-1.6 3.72-3.72 3.72-3.72-1.6-3.72-3.72Zm1.36-6.84-.72-17.76h6.16l-.72 17.76h-4.72Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70100",
    x1: -3.364,
    x2: 109.762,
    y1: 74.074,
    y2: 4.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.025,
    stopColor: "#689DDB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#7FEDAD"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70100",
    x1: 0,
    x2: 100,
    y1: 26.456,
    y2: 26.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#5B71F3"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#3285F3"
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint2_radial_21134_70100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(56.227 66.96) scale(29.5917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FF8E45"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.483,
    stopColor: "#FA7C51"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F46362"
  }))));
};
ColoredIllustrationCreditRefusalRational.displayName = 'ColoredIllustrationCreditRefusalRational';
export default withProvisionalOverrideFromContext(ColoredIllustrationCreditRefusalRational);
//# sourceMappingURL=index.js.map